var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Contact Me")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("Email: "+_vm._s(_vm.email))]),_vm._v(" "),_c('li',[_vm._v("Website: "+_vm._s(_vm.web))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427d4e1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 